// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"ea382021","987":"feb7806e"}[chunkId] + ".chunk.js";
};